const ApplyContent = ({ children, className }) => {
  return (
    <div className={`flex flex-col h-full w-full gap-12 p-6 overflow-scroll no-scrollbar mobile:px-2 mobile:pb-32 ${className}`}>
      {children}
    </div>
  )
}

export default ApplyContent;